import React from "react";
import { Helmet } from "react-helmet-async";

const AccessibilityStatement = () => {
  return (
    <section className="min-h-screen py-20 px-4 bg-white text-black selection:bg-[#1e6091]/30">
      <Helmet>
        <title>Accessibility Statement | Option Bricks</title>
        <meta
          name="description"
          content="Option Bricks is committed to ensuring digital accessibility for people with disabilities. Learn about our ongoing efforts to improve the user experience for everyone."
        />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-black mb-6 mt-20 tracking-tight">
            Accessibility Statement
          </h1>
          <div className="h-1 w-24 bg-[#1e6091] mx-auto rounded-full mb-6" />
          <p className="text-gray-700 max-w-2xl mx-auto text-lg">
            Option Bricks is committed to ensuring digital accessibility for
            people with disabilities.
          </p>
        </div>

        {/* Content */}
        <div className="space-y-10 text-sm leading-relaxed text-gray-800">
          <div>
            <h2 className="text-xl font-bold mb-3 text-black">
              Our Commitment
            </h2>
            <p>
              Option Bricks strives to ensure that its services are accessible
              to people with disabilities. We have invested a significant
              amount of resources to help ensure that our website is made
              easier to use and more accessible for people with disabilities,
              with the strong belief that every person has the right to live
              with dignity, equality, comfort, and independence.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3 text-black">
              Conformance Status
            </h2>
            <p>
              We aim to conform to the Web Content Accessibility Guidelines
              (WCAG) 2.1 Level AA standards. These guidelines explain how to
              make web content more accessible for people with disabilities
              and more user-friendly for everyone.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3 text-black">
              Measures Taken
            </h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Providing a &ldquo;Skip to Main Content&rdquo; link for
                keyboard users.
              </li>
              <li>
                Ensuring all images have meaningful alternative text
                descriptions.
              </li>
              <li>
                Using semantic HTML elements to convey document structure.
              </li>
              <li>
                Maintaining sufficient colour contrast ratios for text and
                interactive elements.
              </li>
              <li>
                Ensuring forms have properly associated labels and error
                messages.
              </li>
              <li>
                Trapping keyboard focus within modal dialogs when they are
                open.
              </li>
              <li>
                Providing visible focus indicators for all interactive
                elements.
              </li>
              <li>
                Including <code>scope</code> attributes on table headers for
                screen-reader compatibility.
              </li>
              <li>
                Providing an on-page accessibility widget for font-size
                adjustments.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3 text-black">Feedback</h2>
            <p>
              We welcome your feedback on the accessibility of the Option
              Bricks website. Please let us know if you encounter
              accessibility barriers on our website:
            </p>
            <ul className="list-none mt-3 space-y-1">
              <li>
                <strong>Email:</strong>{" "}
                
                <a  href="mailto:compliance@optionbricks.in"
                  className="text-[#1e6091] underline hover:text-[#185076]"
                >
                  compliance@optionbricks.in
                </a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                
                 <a href="tel:+919082280240"
                  className="text-[#1e6091] underline hover:text-[#185076]"
                >
                  +91 90822 80240
                </a>
              </li>
            </ul>
            <p className="mt-3">
              We try to respond to feedback within 5 business days.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3 text-black">
              Continuous Improvement
            </h2>
            <p>
              We are continually improving the user experience for everyone
              and applying the relevant accessibility standards to ensure we
              provide equal access to all users.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessibilityStatement;